import { getRequest, putRequest } from "../api/apiService";

const systemConfigService = {
  /**
   * Fetches the system wide configuration.
   */
  getConfig: async () => {
    try {
      const response = await getRequest("/api/config");
      return response.data;
    } catch (error) {
      console.error("Error fetching system configuration:", error);
      throw error;
    }
  },

  /**
   * Updates the system wide configuration.
   * @param {Object} config The configuration object to save.
   */
  updateConfig: async (config) => {
    try {
      const response = await putRequest("/api/config", config);
      return response.data;
    } catch (error) {
      console.error("Error updating system configuration:", error);
      throw error;
    }
  }
};

export default systemConfigService;
